import React from 'react';
import classNames from 'classnames';

import css from './IconArrow.module.css';

const DIRECTION_RIGHT = 'right';
const DIRECTION_LEFT = 'left';

/**
 * Icon with arrow head pointing to given direction and with given size.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {('right' | 'left' | 'down' | 'up')} props.direction
 * @param {('small' | 'big')} props.size
 * @returns {JSX.Element} arrow head icon
 */
const IconArrow = props => {
  const { className, rootClassName, direction } = props;
  const classes = classNames(rootClassName || css.root, className);

  const isRight = direction === DIRECTION_RIGHT;
  const isLeft = direction === DIRECTION_LEFT;

  if (isRight) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="42"
        height="42"
        fill="none"
        viewBox="0 0 42 42"
        className = {classes}
      >
        <path fill="#D42476" d="M0 .42h42v41.16H0z"></path>
        <g clipPath="url(#clip0_437_12068)">
          <path
            fill="#E6E4FF"
            d="M12.195 22.392H25.75l-5.134 6.067 1.907 1.615 7.559-8.933-7.559-8.932-1.907 1.615 5.134 6.068H12.195z"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_437_12068">
            <path
              fill="#fff"
              d="m21 7.136 14.142 14.142L21 35.42 6.858 21.278z"
            ></path>
          </clipPath>
        </defs>
      </svg>
    );
  } else if (isLeft) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="42"
        height="42"
        fill="none"
        viewBox="0 0 42 42"
        className = {classes}
      >
        <path fill="#D42476" d="M0 .42h42v41.16H0z"></path>
        <g clipPath="url(#clip0_437_12065)">
          <path
            fill="#E6E4FF"
            d="M29.806 20.164H16.25l5.134-6.067-1.907-1.615-7.559 8.932 7.559 8.933 1.907-1.615-5.134-6.068h13.555z"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_437_12065">
            <path
              fill="#fff"
              d="M21 35.42 6.858 21.278 21 7.136l14.142 14.142z"
            ></path>
          </clipPath>
        </defs>
      </svg>
    );
  } else {
    return null
  }
};

export default IconArrow;
